import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Accordion from '../../Components/Accordion'
import { Tabs } from 'antd';
import descriptions from './descriptions'
import { Line } from 'react-chartjs-2'
import moment from 'moment'

import './servicos.css'

let options = {
    responsive: true,
    legend: {
       position: 'bottom',
       labels: {
           usePointStyle: true,
           fontColor: '#fff',
           fontSize: 14,
           fontFamily: 'Arial',
           boxWidth: 10
       }
    },
    scales: {
       xAxes: [{
          ticks: {
             fontColor: "#fff",
          },
          gridLines: {
             display: false,
             color: "#F7D9F8"
           },
       }],
       yAxes: [{
          ticks: {
             fontColor: "#fff",
             callback: function(value, index, values){ return value + '%'},
          },
          gridLines: {
             // display: false,
             color: "#F7D9F8"
           },
       }]
    },
    tooltips: {
         enabled: true,
         mode: 'single',
         callbacks: {
            label: function(tooltipItems, data) { 
                return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel+'%';
            }
        }
     },
 }

export default class Asa extends Component {
    constructor() {
        super();
          this.state = {
          height: '263px',
          class: '',
          visible: false,
          rent0w: '',
          chartData: '',
        };
    }

    componentDidMount = async () => {
        if(window.innerWidth <= 767){
            this.setState({
                height: '400px',
                heightSpirit: '500px'
            })
        }
        this.calculateChart()
    }

    calculateChart() {
        let labels = []
        let rend01 = []
        let rend02 = []
        let rend03 = []
        let rend0w = []

        var past_date = new Date('01/01/2019');
        var current_date = new Date();
                                
        var difference = (current_date.getFullYear()*12 + current_date.getMonth()) - (past_date.getFullYear()*12 + past_date.getMonth());
                
        for(let i = 0; i < difference; i++) {
            if(i === 0) {
                labels.push("Jan/2019")
            } else {
                var dt_helper = moment('2019-01-01')
                var dt_somada = moment(dt_helper).add(i, 'M')
                
                labels.push(dt_somada.format('MMM')+"/"+dt_somada.format('Y'))
            }
            rend01.push(0.79)
            rend02.push(0.94)
            rend03.push(1.12)
            rend0w.push(1.38)
        }
        let newData = {
            labels: labels,
                datasets: [
                    {
                    label: 'Flow Digital Assets ASA | 4 meses',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(219, 86, 224, 1)',
                    borderColor: 'rgba(219, 86, 224, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(219, 86, 224, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 8,
                    pointHoverRadius: 8,
                    pointHoverBackgroundColor: 'rgba(219, 86, 224, 1)',
                    pointHoverBorderColor: 'rgba(219, 86, 224, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 8,
                    data: rend01
                    }, {
                        label: 'Flow Digital Assets ASA | 8 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(215, 209, 236, 1)',
                        borderColor: 'rgba(215, 209, 236, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(215, 209, 236, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend02
                    }, {
                        label: 'Flow Digital Assets ASA | 10 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(64, 50, 115, 1)',
                        borderColor: 'rgba(64, 50, 115, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(64, 50, 115, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(64, 50, 115, 1)',
                        pointHoverBorderColor: 'rgba(64, 50, 115, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend03
                    },
                    {
                        label: 'Flow Digital Assets ASA | 12 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(128, 33, 126, 1)',
                        borderColor: 'rgba(128, 33, 126, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(128, 33, 126, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(128, 33, 126, 1)',
                        pointHoverBorderColor: 'rgba(128, 33, 126, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend0w
                    }
                ]
        }
        this.setState({
            chartData: newData
        })
    }

    render() {
        return (
            <>
                <div className="productContent">
                    <div className='main sobreTabs'>
                    <Tabs defaultActiveKey="1" centered>
                        <Tabs.TabPane tab="Sobre o fundo" key="1">
                            <Container>
                                <Row style={{marginTop: '30px'}}>
                                    <Col md={12}>
                                        <Accordion status={false} type="normal" active="accordion-active" title="Objetivo do fundo" content={descriptions[0]['objetivo']} />
                                        <Accordion status={true} type="normal" active="" title="Política de investimento" content={descriptions[0]['politica']} />
                                        <Accordion status={true} type="normal" active="" title="Público Alvo" content={descriptions[0]['publico']} />
                                        <Accordion status={true} type="tabs" active="" title="Opções de Vencimento da Aplicação" content='tabs' />
                                        <hr style={{background: '#fff', height: '2px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Valor mínimo de aplicação: </span>R$ 500,00</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Aplicação: </span>D+1</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Resgate: </span>D+45 corridos após finalização.</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Gestão: </span>Flow.in (Gestor)</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Site Administrador: </span>www.somosflow.in</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Taxa de administração: </span>0% (ZERO)</label>
                                        <hr style={{background: '#F2E9F2', margin: '15px 0px 15px 0px'}} />
                                        <label className="labelCard text-white"><span className="tx-pink">Escala de Risco Flow.in (0-5): </span>Nível 2 - Baixo</label>
                                        <hr style={{background: '#fff', height: '2px', marginBottom: '35px'}} />
                                        {/* <Link to="/contratos" className="btnContratarFundo" >Investir agora</Link> */}
                                    </Col>
                                </Row>
                            </Container>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Rentabilidade histórica" key="2">
                            <Container>
                                <Row style={{marginTop: '30px'}}>
                                    <Col md={12}>
                                        <h4 className='subTitle text-white text-left'>PERFORMANCE/MÊS</h4><br />
                                        <div className="wrapperGraph">
                                            <div className="wrapperAreaGraph">
                                                <Line data={this.state.chartData} options={options}/>
                                            </div>
                                        </div>
                                        <br />
                                        <small className="lineTerm text-white">
                                            *As rentabilidades dispostas no gráfico são relativas a performance dos produtos em cada mês.
                                        </small><br /><br />
                                        <small className="lineTerm text-white mt-5">- Rentabilidade passada não representa garantia de rentabilidade futura.<br />- A rentabilidade divulgada não é líquida de impostos.<br />- Fundos de investimento não contam com garantia do administrador, do gestor, de qualquer mecanismo de seguro ou Fundo Garantidor de Crédito - FGC.</small>
                                    </Col>
                                </Row>
                            </Container>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
            </>
        )
    }
}